<template lang="pug">
  .b-contact-tile
    UserAvatar._avatar(:user="item.user" :size="40" @click="onClick")
    ._info
      span._name(@click="onClick") {{ item.user.name }} {{ item.user.surname }}
      span._date(@click="onClick" v-if="item.position") {{ item.position }}
      span._date(@click="onClick" v-else) {{ item.user.email}}
    EllipsisMenu._menu(v-if="!item.isRequest" :items="ellipsis")
    ._item-actions(v-if="item.isRequest")
      template(v-if="item.user === item.author")
        Btn(sm @click="$emit('accept')") Принять
        Btn(sm @click="$emit('remove')" grey transparent) Отклонить
      Btn(v-else sm @click="$emit('remove')" grey transparent) Отменить заявку
    UserDetailPopup(ref="userDetailPopup")
      ._popup-buttons
        Btn(lg round grey @click="$emit('remove');") Удалить
        Btn(lg round @click="$emit('invite');") Пригласить
</template>

<script>
import contactApi from '@/api/contact';

import UserDetailPopup from '@/components/UserDetailPopup.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';

export default {
  name: 'ContactTile',
  components: { UserAvatar, EllipsisMenu, UserDetailPopup },
  props: {
    item: Object,
    editable: Boolean,
    menu: Array,
    emitClick: Boolean,
  },
  data() {
    return {
      popupOpened: false,
    };
  },
  computed: {
    ellipsis() {
      if (this.menu) return this.menu;

      if (!this.editable) return [
        { text: 'Пригласить в проект',  icon: 'add',   handler: () => { this.$emit('invite'); } }, // eslint-disable-line
      ];

      return [
        { text: 'Пригласить в проект',  icon: 'add',   handler: () => { this.$emit('invite'); } }, // eslint-disable-line
        { text: 'Удалить',              icon: 'trash', handler: () => { this.$emit('remove'); } }, // eslint-disable-line
      ];
    },
  },
  methods: {
    onClick() {
      if (this.emitClick) {
        this.$emit('click');
        return;
      }
      if (this.item.isRequest) return;

      contactApi.fetchItem(this.item.id, [], true).then((r) => {
        const userData = this.$store.state.auth.user?.id === r.author.id ? r.acceptor : r.author;
        this.$refs.userDetailPopup.open(userData);
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .contact-tile {
    display: grid;
    grid-template-columns: 40px 1fr 24px;
    column-gap: 20px;
    row-gap: 15px;

    background: #fff;
    padding: 15px 20px;
    border-radius: 6px;
    box-shadow: 0 6px 12px rgb(0 0 0 / 8%);

    &__menu {
      display: none;
    }

    &:hover &__menu {
      display: block;
    }

    &__item-actions {
      grid-column: 2 / 2 span;
      grid-row: 2;
      display: flex;
      gap: 15px;
    }

    &__user {
      grid-column: 1 / 2 span;
    }

    &__info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 2px;
    }

    &__name {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: #1E3147;
      transition: color 0.3s;
      cursor: pointer;

      &:hover {
        color: var(--color-hover);
      }
    }

    &__date {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.01em;
      color: #788CA1;
    }

    &__popup-buttons {
      display: flex;
      justify-content: space-between;
    }
  }
</style>
